export default "__VITE_ASSET__e_lja3wj__"